import { render } from "./incident_emp.vue?vue&type=template&id=5dbd78e6"
import script from "./incident_emp.vue?vue&type=script&lang=js"
export * from "./incident_emp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__